export default {
    data() {
        return {
            /* ios bug  该版本会出现跳转到下级页面再返回时 页面空白的问题（随便点击屏幕恢复正常）*/
            iosBug : false,//navigator.userAgent.indexOf('iPhone OS')!==-1,
            remainHeight: 30, // 默认剩余高度为30时，就加载
            customTel: "0532-58552955", //客服及举报电话
            timer: null, //函数防抖时间戳
            debug:(this.Util.ENV()!=1||returnCitySN.cip=='222.135.186.170'?1:0)
            //isLogin:window.localStorage.getItem('userInfo')&&JSON.parse(window.localStorage.getItem('userInfo')).unionUid?true:false,//是否已登录
            //isLogin:this.$store&&this.$store.getters&&this.$store.getters.getUserInfo('unionUid')?true:false,//是否已登录
        }
    },
    computed: {
        _rootElement() { // 根dom元素
            return this.iosBug ? document.getElementById("app") : document;
        },
        _rootSelector() { //根选择器
            return this.iosBug ? '#app' : "html,body";
        }
    },
    mounted(){
        this._rootElement.addEventListener('scroll', this._scrollHandler);
        //console.log(this.$route)
        //底部通栏导航条存在需要将APP增加2rem底部内边距
        this.freshhomePageNav()
        console.log(this.iosBug);
    },
    destroyed(){
        this._rootElement.removeEventListener('scroll', this._scrollHandler);
    },
    methods: {
        freshhomePageNav:function(){
            if(this.$store&&this.$store.getters.getSourceSwitch('homePage')){
                if(this.$route.name=='Ha'||this.$route.name=='selectHouse'||this.$route.name=='apartment'||this.$route.name=='selectHouseShopOffice'||this.$route.name=='MyHouse'||this.$route.name=='manage'
                  ||this.$route.name=='livingIndex'){
                    var idx_pos = this.$store&&this.$store.getters.getSourceSwitch('use_in_fcgj_app') ? 1 : 0;
                    $('#app').css('paddingBottom','2rem');
                    $('#app').css('height','auto');
                    $('.my_collect').hide()
                    $('.secFixed,.addhouse,.footerword,.footerwordfixed,.supply_btn').css('bottom','2rem')
                    $('.supply_warn').css('bottom','2.8rem');
                    $('.homebar').show();
                    $('.homebar li').removeClass('hover');
                    if(this.$route.name=='livingIndex')$('.homebar li').eq(0).addClass('hover');
                    if(this.$route.name=='MyHouse')$('.homebar li').eq(idx_pos + 0).addClass('hover');
                    if(this.$route.name=='Ha')$('.homebar li').eq(idx_pos + 1).addClass('hover');
                    if(this.$route.name=='selectHouse')$('.homebar li').eq(idx_pos + 1).addClass('hover');
                    if(this.$route.name=='apartment')$('.homebar li').eq(idx_pos + 1).addClass('hover');
                    if(this.$route.name=='selectHouseShopOffice')$('.homebar li').eq(idx_pos + 1).addClass('hover');
                    if(this.$route.name=='manage')$('.homebar li').eq(idx_pos + 2).addClass('hover');
                }else{
                    $('.homebar').hide();
                    $('#app').css('paddingBottom','0rem');
                    $('#app').css('height','100%');
                    $('.my_collect').hide()
                    $('.secFixed,.addhouse,.footerwordfixed,.supply_btn').css('bottom','0rem')
                    $('.supply_warn').css('bottom','1.3rem')
                }
            }
        },
        isLogin(){
            return this.$store&&this.$store.getters&&this.$store.getters.getUserInfo('unionUid')?true:false;
        },
        // 函数防抖功能
        debounce(func, wait = 200) {
            if (this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(func, wait);
        },
        _tel(phoneNum){
            if(this.$store.getters.getChannel=='icbc.rong.e') {
              //拨打电话
              ICBCUtil.callPhoneNumber(phoneNum);
            } else if(this.$store.getters.getChannel=='icbc.serv.mobile.applet'){
                //拨打电话
                ICBCUtil.callPhoneNumber(phoneNum);
            }else{
                location.href='tel:'+phoneNum;
            }
        },
        _scrollHandler() {
            // TODO:: 组件按需重写该方法即可
        },
        _scrollLoad() {
            let scrollTop = this._getScrollTop();
            let domHeight = this._getDomHeight();

            let scrollHeight = scrollTop + window.innerHeight + this.remainHeight;
            // 滚动高度 + 可视高度 + 剩余高度 > 文档高度
            return scrollHeight > domHeight;
        },
        _getScrollTop() {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (this.iosBug) {
                scrollTop = document.getElementById('app').scrollTop;
            }
            return scrollTop;
        },
        _getDomHeight() {
            let domHeight = document.documentElement.scrollHeight;
            if (this.iosBug) {
                domHeight = document.getElementById('app').scrollHeight;
            }
            return domHeight;
        },
        // 合并数组或对象
        // raw 是原对象
        // ext 是需要合并的对象
        // override 是否覆盖 raw 原来的key， 默认会覆盖
        extend(raw, ext, override = true) {
            for(let key in ext){
                if(!raw.hasOwnProperty(key) || override){
                    raw[key]=ext[key];
                }
            }
            return raw;
        },
        // 动态加载 js 及 回调
        async loadScript(src) {
            await new Promise(resolve => {
                // 如果已经加载了本js，直接调用回调
                if (this._checkIsLoadScript(src)) {
                    return resolve();
                }
                let scriptNode = document.createElement("script");
                scriptNode.setAttribute("type", "text/javascript");
                scriptNode.setAttribute("src", src);
                document.body.appendChild(scriptNode);
                if (scriptNode.readyState) { //IE 判断
                    scriptNode.onreadystatechange = () => {
                        if (scriptNode.readyState == "complete" || scriptNode.readyState == 'loaded') {
                            resolve();
                        }
                    }
                } else {
                    scriptNode.onload = () =>  resolve();
                }
            })
        },
        // 检测是否加载了 js 文件
        _checkIsLoadScript(src) {
            const scriptObjs = Array.from(document.getElementsByTagName('script'));
            return scriptObjs.find(ele => ele.src.includes(src));
        },
        // 反转义 html 实体字符
        escape2Html (text) {
            let temp = document.createElement("span");
            temp.innerHTML = text;
            let output = temp.innerText || temp.textContent;
            temp = null;
            return output;
        },
      redirectToLogin(){
        let that=this;
        if(this.$store.getters.getChannel=='cityhouse.mobile.applet'){
          if(this.isWeixinBrowser()){
            wx.miniProgram.navigateTo({ url:'/pages/index/index?needLogin=true'});
          }
        }else{
          this.redirectToLogin_()
        }
      },
        redirectToLogin_(){
            this.$router.push({name: 'Oauth',query: {state: this.$store.getters.getChannel,to:encodeURIComponent(location.href)}});
        },
        //跳转补充手机号页面.../补充完毕返回验证继续操作
        doAddPhone(type=1,methodName=""){
            let hasPhone=this.$store.getters.getUserInfo('phone');
            let key="doAddPhone_lastDo";
            if(type==1){
                if(!hasPhone){//判断是否需要跳转
                    window.sessionStorage.setItem(key,methodName);
                    this.$router.push({name:'manageInfo',params:"mobile"});
                    return false;
                }
            }else if(type==2){//补充完手机
                if(hasPhone){
                    let methodstr=window.sessionStorage.getItem(key);
                    if(methodstr){
                        if(eval(('typeof '+methodstr).replace(/\(.*\)/g,''))=='function'){
                            eval(methodstr);
                         }
                    }
                }
                window.sessionStorage.removeItem(key);
            }
            return true;
        },
        isWeixinBrowser() {
            let ua = navigator.userAgent.toLowerCase();
            return /micromessenger/.test(ua) ? true : false;
        },
        console(msg){
            if(this.debug){
                console.log(msg);
            }
        },
        reImg(imgUrl){
            console.log(imgUrl.replace('http://','https://'))
            return imgUrl.replace('http://','https://');
        },
        getPriceDomain(){
            var aa=this.$store.getters.getSourceSwitch('moreTrend');
                var a=aa.split("://")[1].split('/')[0]
           var d= aa.match(/channel=\w+/i)
            return {
                domain:a?a:'',
                channel:d[0]?d[0]:'',
            }
        },
        showField:function(val,unit,int){
            unit=unit==undefined?'':unit;
            int=int==undefined?false:int;
            if(1){
                if(val===undefined||val==='undefined'||val===null)return '--';
                if(typeof val=='string')return val+unit;
                if(!int&&val&&(val+'').indexOf('.')>=0){
                    if(val>0){
                        val=parseFloat(val).toFixed(2)
                    }else{
                        val='-'+(Math.abs(parseFloat(val))).toFixed(2)
                    }
                }else{
                    val=Math.round(val)
                }
                val=this.$options.filters.thousandPrice(val);
                return val+unit;
            }else{
                return '*';
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/mixin.js